<template>
  <v-row align="start" justify="start" wrap>
    <v-flex shrink v-for="field in fields" :key="field" pa-1>
      <div class="text-xs-center">
        <v-btn
          @click="handleClick(field)"
          rounded
          :color="getColour(field)"
          class="text-none"
          dark
        >{{prettyFields[field]}}</v-btn>
      </div>
    </v-flex>
  </v-row>
</template>

<script>
export default {
  name: "fields_buttons",
  props: {
    fields: Array,
    prettyFields: Object
  },
  methods: {
    handleClick: function(field) {
      let tagToInsert = "<" + field + ">";
      this.$emit("insertTag", tagToInsert);
    },
    getColour: function(field) {
      if (field.substring(field.length - 7, field.length + 1) == "Message") {
        return "secondary";
      } else {
        return "primary";
      }
    }
  }
};
</script>